import { BoxProps } from '../BoxNew'
const TextLabelDimens = {
  CONTAINER_HEIGHT: 16,
  BOREDR_RADIUS: 4,
  PADDING_HORIZONTAL: 8,
  PADDING_VERTICAL: 5,
  TEXT_LABEL_FULL_WIDTH: '100%',
  LABEL_LEFT: 6,
  MAP_LABEL_WIDTH: 72,
  MAP_LABEL_HEIGHT: 32,
  BORDER_WIDTH: 1,
  BORDER_PADDING_TOP: 4,
  ARROW_LEFT_WIDTH: 5,
  ARROW_RIGHT_WIDTH: 5,
  ARROW_TOP_WIDTH: 10,
  ROUND_EDGED_RADIUS: 24,
  ROUND_EDGED_PADDING_HORIZONTAL: 10,
  ROUND_EDGED_PADDING_VERTICAL: 6,
}
const defaultStyle = {
  topContainer: {} as BoxProps,
  border: {} as BoxProps,
  strikerStyle: {},
  arrow: {},
}
const textLabelTypes = {
  WithBg: {
    ...defaultStyle,
    topContainer: {
      flexDirection: 'row',
      height: TextLabelDimens.CONTAINER_HEIGHT,
      borderRadius: TextLabelDimens.BOREDR_RADIUS,
      paddingHorizontal: TextLabelDimens.PADDING_HORIZONTAL,
      paddingVertical: TextLabelDimens.PADDING_VERTICAL,
      alignItems: 'center',
    } as BoxProps,
    border: {
      alignContent: 'center',
      backgroundColor: 'PRIMARY',
    } as BoxProps,
  },

  WithBgRightRounded: {
    ...defaultStyle,
    topContainer: {
      flexDirection: 'row',
      height: 30,
      borderTopEndRadius: TextLabelDimens.BOREDR_RADIUS,
      borderBottomEndRadius: TextLabelDimens.BOREDR_RADIUS,
      paddingHorizontal: TextLabelDimens.PADDING_HORIZONTAL,
      paddingVertical: TextLabelDimens.PADDING_VERTICAL,
      alignItems: 'center',
    } as BoxProps,
    border: {
      alignContent: 'center',
    } as BoxProps,
  },

  WithStrike: {
    ...defaultStyle,
    topContainer: {
      alignItems: 'center',
      position: 'absolute',
    } as BoxProps,
    border: {
      alignContent: 'center',
    } as BoxProps,
    strikerStyle: {
      position: 'absolute',
      transform: [{ rotate: '161deg' }],
      top: 10,
      height: 1,
      width: TextLabelDimens.TEXT_LABEL_FULL_WIDTH,
      borderBottomColor: 'BLACK',
      borderBottomWidth: 1,
      alignSelf: 'center',
      left: 'LABEL_LEFT',
    } as BoxProps,
  },

  MapLabel: {
    ...defaultStyle,
    topContainer: {
      flexDirection: 'column',
      alignContent: 'center',
    } as BoxProps,
    border: {
      width: TextLabelDimens.MAP_LABEL_WIDTH,
      height: TextLabelDimens.MAP_LABEL_HEIGHT,
      borderWidth: TextLabelDimens.BORDER_WIDTH,
      paddingTop: TextLabelDimens.BORDER_PADDING_TOP,
      borderColor: 'PRIMARY',
      borderRadius: TextLabelDimens.BOREDR_RADIUS,
    } as BoxProps,
    arrow: {
      borderLeftWidth: TextLabelDimens.ARROW_LEFT_WIDTH,
      borderRightWidth: TextLabelDimens.ARROW_RIGHT_WIDTH,
      borderTopWidth: TextLabelDimens.ARROW_TOP_WIDTH,
      borderStyle: 'solid',
      backgroundColor: 'TRANSPARENT',
      borderLeftColor: 'TRANSPARENT',
      borderRightColor: 'TRANSPARENT',
      borderTopColor: 'PRIMARY',
      alignSelf: 'center',
      alignContent: 'center',
    } as BoxProps,
  },

  RoundEdgedLabel: {
    ...defaultStyle,
    topContainer: {
      flexDirection: 'column',
      alignContent: 'center',
      margin: 3,
    } as BoxProps,
    border: {
      borderWidth: TextLabelDimens.BORDER_WIDTH,
      borderRadius: TextLabelDimens.ROUND_EDGED_RADIUS,
      paddingHorizontal: TextLabelDimens.ROUND_EDGED_PADDING_HORIZONTAL,
      paddingVertical: TextLabelDimens.ROUND_EDGED_PADDING_VERTICAL,
      backgroundColor: 'BLACK_STRIKE',
    } as BoxProps,
  },
}

export default textLabelTypes
